import cx from 'classix';
import Image from 'next/image';
import QRCode from 'react-qr-code';

import { getAppFlyerLink } from '@/features/roomster-app/hooks/use-app-flyer-link';
import { Link } from '@/i18n/routing';
import { DOWNLOAD_APP_LINKS } from '@/shared/constants/links-constants';

import styles from './banner.module.scss';

// const fullStars = Array.from({ length: 4 }, (_, index) => index);

export default function Banner() {
  const qrCodeLink = getAppFlyerLink('desktop', 'qrCode');

  return (
    <div
      className={cx(
        styles.banner,
        // !isShow && styles.banner__hidden,
      )}
    >
      <div className={styles.banner_phone}>
        <Image
          src="/images/banner/phone-en.webp"
          alt="phone banner"
          priority
          fill
        />
      </div>
      <div className={styles.banner_appLinks}>
        <div className={styles.banner_qrcode}>
          <QRCode
            size={160}
            style={{
              height: 'auto',
              maxWidth: '100%',
              width: '100%',
            }}
            value={`${qrCodeLink.pathname}?${qrCodeLink.query}`}
            viewBox="0 0 160 160"
          />
          <p>Download app</p>
          {/* <div className={styles.banner_ratingBackground}> */}
          {/*   <Image */}
          {/*     src="/images/banner/landing-banner.webp" */}
          {/*     alt="landing bannerr" */}
          {/*     fill */}
          {/*   /> */}
          {/* </div> */}
          {/* <div className={styles.startContainer}> */}
          {/*   {fullStars.map((item) => ( */}
          {/*     <div */}
          {/*       key={item} */}
          {/*       className={ */}
          {/*         styles.startContainer_item */}
          {/*       } */}
          {/*     > */}
          {/*       <BsStarFill /> */}
          {/*     </div> */}
          {/*   ))} */}
          {/*   <div */}
          {/*     className={styles.startContainer_item} */}
          {/*   > */}
          {/*     <BsStarHalf /> */}
          {/*   </div> */}
          {/* </div> */}
        </div>
        <div className={styles.marketingList}>
          <Link
            aria-label="appStore"
            className={styles.marketingList_link}
            href={DOWNLOAD_APP_LINKS.appStore}
            rel="nofollow"
            target="_blank"
          >
            <Image
              src="/images/banner/tunes.webp"
              alt="full star"
              fill
            />
          </Link>
          <Link
            aria-label="googlePlay"
            className={styles.marketingList_link}
            href={DOWNLOAD_APP_LINKS.googlePlay}
            rel="nofollow"
            target="_blank"
          >
            <Image
              src="/images/banner/google-play.webp"
              alt="full star"
              fill
            />
          </Link>
        </div>
      </div>
    </div>
  );
}
